import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { Permission, Role, RolePermissionAssignment, RoleWithPermissions } from '../models/access.model';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private readonly baseUrl = `${environment.subscriptionApiUrl}/api`;

  constructor(private http: HttpClient) {}

  /**
   * Permissions granted by a role. The API returns the role wrapped alongside
   * its permissions, so unwrap it and hand callers the flat list they expect.
   */
  getPermissionsForRole(roleId: string): Observable<Permission[]> {
    return this.getRoleWithPermissions(roleId).pipe(map(result => result?.permissions ?? []));
  }

  getPermissions(): Observable<Permission[]> {
    return this.http.get<Permission[]>(`${this.baseUrl}/permissions/all`);
  }

  getRoleWithPermissions(roleId: string): Observable<RoleWithPermissions> {
    return this.http.get<RoleWithPermissions>(`${this.baseUrl}/permissions/permissions/${roleId}`);
  }

  updateRolePermissions(roleId: string, permissionIds: string[]): Observable<void> {
    // const payload: RolePermissionAssignment[] = permissionIds.map(pid => ({
    //   roleId,
    //   permissionId: pid,
    // }));
    return this.http.post<void>(`${this.baseUrl}/permissions/${roleId}/assignpermissions`, permissionIds);
  }

  createRole(role: Partial<Role>): Observable<Role> {
    return this.http.post<Role>(`${this.baseUrl}/roles`, role);
  }

  updateRole(roleId: string, role: Partial<Role>): Observable<Role> {
    return this.http.put<Role>(`${this.baseUrl}/roles/${roleId}`, role);
  }

  deleteRole(roleId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/roles/${roleId}`);
  }

  createPermission(permission: Partial<Permission>): Observable<Permission> {
    return this.http.post<Permission>(`${this.baseUrl}/permissions`, permission);
  }

}
